import React, { lazy, Suspense, use } from "react";
import { connect } from "react-redux";
import "./CourseList.scss";
import { AuthorizedWrapper } from "../../Other/AuthorizedWrapper";
import { Loading } from "../../Other/Loading";
import { useLocation } from "react-router-dom";
const StudentList = lazy(
  () => import("./CreateCourse/CourseListSection/StudentCourseList")
);
const AdminCourseList = lazy(
  () => import("./CreateCourse/CourseListSection/AdminCourseList")
);
const CourseInstructor = lazy(
  () => import("./CreateCourse/CourseListSection/CourseListInstructor")
);
function CourseList(props) {
  //console.log("props", props);
  const location=useLocation();
  const parseAndShortDescription = (description) => {
    const parsed = description?.replace(/<[^>]*>/g, "");
    if (parsed?.length > 180) {
      const shortenend = parsed?.slice(0, 280);
      return shortenend;
    }
    return parsed;
  };
  return (
    <>
      <AuthorizedWrapper authorizedRoles={["Instructor"]}>
        <Suspense fallback={<Loading />}>
          <CourseInstructor
            parseAndShortDescription={parseAndShortDescription}
          />
        </Suspense>
      </AuthorizedWrapper>
      <AuthorizedWrapper authorizedRoles={["Admin", "Institute"]}>
        <Suspense fallback={<Loading />}>
          <AdminCourseList
            type={location?.state?.type || ""}
            parseAndShortDescription={parseAndShortDescription}
          />
        </Suspense>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Student"]}>
        <Suspense fallback={<Loading />}>
          <StudentList parseAndShortDescription={parseAndShortDescription} />
        </Suspense>
      </AuthorizedWrapper>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    courses: state.course.myCourses || [],
    user: state.users?.user,
  };
};

export default connect(mapStateToProps)(CourseList);
